import { doc, setDoc, getDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * @fileoverview Servicio para manejar estado de downgrade pendiente
 * Guarda en Firestore cuando un usuario necesita completar el wizard de downgrade
 */

export interface PendingDowngrade {
  userId: string;
  familyId: string;
  fromPlanId: string;
  toPlanId: string;
  reason: 'expiration' | 'cancellation' | 'manual';
  expirationReason?: string;
  createdAt: any;
}

/**
 * Marca que un usuario tiene un downgrade pendiente
 */
export async function setPendingDowngrade(
  userId: string,
  familyId: string,
  fromPlanId: string,
  toPlanId: string,
  reason: PendingDowngrade['reason'],
  expirationReason?: string
): Promise<void> {
  try {
    const pendingDoc = doc(db, 'pending_downgrades', userId);
    
    await setDoc(pendingDoc, {
      userId,
      familyId,
      fromPlanId,
      toPlanId,
      reason,
      expirationReason: expirationReason || '',
      createdAt: serverTimestamp(),
    });
    
    console.log('✅ Pending downgrade guardado para usuario:', userId);
  } catch (error) {
    console.error('Error guardando pending downgrade:', error);
    throw error;
  }
}

/**
 * Obtiene el downgrade pendiente de un usuario
 */
export async function getPendingDowngrade(userId: string): Promise<PendingDowngrade | null> {
  try {
    const pendingDoc = doc(db, 'pending_downgrades', userId);
    const docSnap = await getDoc(pendingDoc);
    
    if (!docSnap.exists()) {
      return null;
    }
    
    return docSnap.data() as PendingDowngrade;
  } catch (error) {
    console.error('Error obteniendo pending downgrade:', error);
    return null;
  }
}

/**
 * Elimina el downgrade pendiente de un usuario (después de completar wizard)
 */
export async function clearPendingDowngrade(userId: string): Promise<void> {
  try {
    const pendingDoc = doc(db, 'pending_downgrades', userId);
    await deleteDoc(pendingDoc);
    
    console.log('✅ Pending downgrade eliminado para usuario:', userId);
  } catch (error) {
    console.error('Error eliminando pending downgrade:', error);
    throw error;
  }
}

/**
 * Verifica si un usuario tiene un downgrade pendiente
 */
export async function hasPendingDowngrade(userId: string): Promise<boolean> {
  const pending = await getPendingDowngrade(userId);
  return pending !== null;
}
